import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import AppCard2 from '../AppCards/AppCard2';
import InlineStyled from '../InlineStyled/InlineStyled';

const AppDocumentProcessingBox = () => {
  return (
    <InlineStyled
      as={AppCard2}
      $style={{
        textAlign: 'center',
        width: '448px !important',
        margin: '0 auto 60px auto',
      }}
    >
      <InlineStyled
        as={Spin}
        indicator={
          <InlineStyled
            as={LoadingOutlined}
            $style={{ fontSize: '48px !important', marginBottom: 8 }}
            spin
          />
        }
      />
      <InlineStyled
        $style={{
          color: '#06F',
          fontSize: 28,
          fontWeight: 600,
        }}
        className='mb-8'
      >
        Document is Processing
      </InlineStyled>
      <InlineStyled
        $style={{
          color: '#465364',
          textAlign: 'center',
          fontSize: 14,
          lineHeight: 'normal',
        }}
      >
        The document is being processed meanwhile you can view other scanned PDFs.
      </InlineStyled>
    </InlineStyled>
  );
};

export default AppDocumentProcessingBox;
